import { render, staticRenderFns } from "./ApprovalQueueCard.vue?vue&type=template&id=7723b8ca&scoped=true&"
import script from "./ApprovalQueueCard.vue?vue&type=script&lang=js&"
export * from "./ApprovalQueueCard.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalQueueCard.vue?vue&type=style&index=0&id=7723b8ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7723b8ca",
  null
  
)

export default component.exports